import RadioGroup from "../inputs/RadioGroup";
import { RadioGroupFieldsetProps } from "./FieldsetProps";
import { RadioButtonField } from "../inputs/InputProps";

import "./Fieldset.scss";

const PrelimChangeOfOwnershipFee: React.FC<RadioGroupFieldsetProps> = ({ currentSelection, setCurrentSelection }) => {
    const fields: RadioButtonField[] = [
        {
            id: "0",
            label: "Yes, a preliminary change of ownership will be enclosed with the document.",
        },
        {
            id: "1",
            label: "No, a preliminary change of ownership will not be enclosed with the document.",
        },
    ];

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>A Preliminary Change of Ownership (
                <abbr title="Preliminary Change of Ownership Record">PCOR</abbr>) is required when recording this
                document and must be submitted at the time of recording (
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=480.3.&lawCode=RTC"
                >
                    <abbr title="Revenue and Taxation Code">RTC</abbr>480.3
                </a>
                ).
                <br />
                <a rel="noopener noreferrer" target="_blank" href="https://sonomacounty.ca.gov/a/102316">
                    Preliminary Change of Ownership Report Form - PDF (872 KB)
                </a>
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="PrelimChangeOfOwnershipFee"
                fields={fields}
            />
            {currentSelection === "1" && (
                <p className="sub-legend">
                    If a <abbr title="Preliminary Change of Ownership Record">PCOR</abbr> is not included, a penalty fee
                    of $20.00 will be applied.
                </p>
            )}
        </fieldset>
    );
};

export default PrelimChangeOfOwnershipFee;
